export const DEAL_HEADERS = [
  "DEAL NAME",
  "COMPANY NAME",
  "PHONE NO",
  "EMAIL",
  "STAGE",
  "PRIORITY",
  "DATE",
  "LOGGED BY",
  "CALLER NAME",
  "PAYMENT TYPE",
  "MACHINE #",
  "REASON FOR CONTACT",
  "COMPLAINT TYPE",
  "ERROR CODE",
  "JUICES PUSHED COUNT",
  "CREDIT NOTE JUICES COUNT",
  "COMMAND CODE",
  "STATUS",
  "REFUNDS (AED)",
  "COMMENTS",
  "ACTIONS",
];

// Rider-onboarding client (Gazmin). This client's pipeline tracks delivery riders
// instead of customers, so it gets its own form, card, table and detail tab.
export const RIDER_CLIENT_ID = "6a96a900cb52712f27f54a76";

export const RIDER_PLATFORM_OPTIONS = ["Noon Minutes", "Talabat", "Noon Food"];

export const RIDER_STATUS_OPTIONS = ["Justtawk", "Gazmin"];

export const RIDER_DEAL_HEADERS = [
  "RIDER ID",
  "RIDER NAME",
  "MOBILE NO",
  "PLATFORM",
  "BIKE NO",
  "VISA NO",
  "CURRENT STORE",
  "PREVIOUS STORE",
  "DESCRIPTION",
  "STATUS",
  "PRIORITY",
  "STAGE",
  "DATE",
  "ACTIONS",
];

// Tatweer (facility services). Leads are service requests, so this client gets its
// own create form; status uses the pipeline stages and technician is the assignee.
export const TATWEER_CLIENT_ID = "6ad09b8d0ca3d3432cb4bcc8";

export const TATWEER_SERVICE_CATEGORY_OPTIONS = ["AC", "Plumbing", "Electrical", "Cleaning", "Other"];

export const TATWEER_FOLLOW_UP_REQUEST = "Pending Complaint Follow-up";

export const TATWEER_REQUEST_TYPE_OPTIONS = ["New Complaint", TATWEER_FOLLOW_UP_REQUEST, "Service Booking"];

export const COMPANY_HEADERS =["COMPANY NAME", "COMPANY WEBSITE", "PHONE"];

export const CONTACT_HEADERS = ["NAME", "COMPANY", "EMAIL", "PHONE"];

// Priority Colors
export const PRIORITY_COLORS = {
  high: { main: "#EF4444", light: "#FEE2E2", text: "#991B1B" },
  medium: { main: "#F59E0B", light: "#FEF3C7", text: "#92400E" },
  low: { main: "#3B82F6", light: "#DBEAFE", text: "#1E3A8A" },
};

// Deal Sources
export const DEAL_SOURCES = [
  "Website",
  "Referral",
  "Cold Call",
  "Email",
  "Social Media",
  "Event",
  "Other",
];

// Priority Levels
export const PRIORITY_LEVELS = ["low", "medium", "high"];

// Interest Options
export const INTEREST_OPTIONS = [
  "Interested",
  "Not Interested",
  "Maybe",
  "Follow Up",
  "No Response",
];

// Disposition Options
export const DISPOSITION_OPTIONS = [
  "Connected",
  "Not Connected",
  "Busy",
  "Switched Off",
  "Wrong Number",
  "Call Back",
  "DND",
  "Others",
];

// Sub-Disposition Options
export const SUB_DISPOSITION_OPTIONS = [
  "Interested",
  "Not interested",
  "Not Reachable",
  "Number Busy",
  "Call Later",
  "Invalid Number",
  "Language Barrier",
  "Already Have Service",
  "Other",
];

// View Types
export const VIEW_TYPES = {
  BOARD: "board",
  LIST: "list",
  COMPANIES: "companies",
  CONTACTS: "contacts",
  APPOINTMENTS: "appointments",
};

// Reason for Contact Options
export const REASON_FOR_CONTACT_OPTIONS = [
  "General Inquiry",
  "Feedback",
  "Sales,Marketing,Investment",
  "Complaints",
];

// Complaint Type Options
export const COMPLAINT_TYPE_OPTIONS = [
  "NIL",
  "AAT Spa",
  "Cannot Remove Juice",
  "Close Cup station",
  "Credit Not Relected",
  "Credit Note Claim",
  "Cup Dropped on left side Metal with AL 49",
  "Cup Dropped with Alarm 13",
  "Cup Over",
  "Door Open",
  "Empty /Half Cup with Seal",
  "Empty Cup Without Seal",
  "Juice Stuck inside Sealer",
  "Machine Hygiene",
  "No Cup Dropped",
  "Orange over",
  "Out of service",
  "Paid but no juice",
  "Refund Follow up",
  "Remove the Cup",
  "Start Button Doesn't work",
  "Transaction in Progress",
];

// Error Code Options (nil + ORF_0 to ORF_105)
export const ERROR_CODE_OPTIONS = [
  "nil",
  ...Array.from({ length: 106 }, (_, i) => `ORF_${i}`),
];

// Machine Number Options
export const MACHINE_NUMBER_OPTIONS = [
  "nil",
  "109",
  "148 Apple Multi",
  "310",
  "311",
  "312",
  "313",
  "314",
  "315",
  "316",
  "317",
  "318",
  "319",
  "359",
  "360",
  "361",
  "362",
  "363",
  "364",
  "365",
  "366",
  "367",
  "368",
  "369",
  "370",
  "381",
  "382",
  "383",
  "384",
  "385",
  "386",
  "387",
  "388",
  "389",
  "390",
  "391",
  "392",
  "393",
  "394",
  "395",
  "396",
  "397",
  "398",
  "399",
  "400",
  "401",
  "402",
  "403",
  "412",
  "541",
  "542",
  "543",
  "544",
  "545",
  "546",
  "547",
  "692",
  "693",
  "694",
  "695",
  "696",
  "697",
  "698",
  "699",
  "700",
  "701",
  "789",
  "790",
  "791",
  "793",
  "794",
  "792",
  "795",
  "796",
  "797",
  "798",
  "799",
  "856",
  "857",
  "858",
  "859",
  "860",
  "861",
  "862",
  "863",
  "864 Orange Multi",
  "1167 AED 5",
  "1168 AED 5",
  "1744 AED 5",
  "1745 AED 5",
];

